import React, {useEffect} from "react";
import Grid from "@mui/material/Grid";
import {useTranslation} from "react-i18next";
import moment from "moment";
import {useDispatch, useSelector} from "react-redux";
import makeStyles from "@mui/styles/makeStyles";
import AgyleButton from "../../../../components/ui/buttons/agyleButton";
import AgyleDatePicker from "../../../../components/ui/fields/agyleDatePicker";
import AgyleTextField from "../../../../components/ui/fields/agyleTextField";
import API from '../../../../app/api';
import {getConfig, reload} from '../../../../store/reducers/booked_admissions';
import AgyleDictionaryField from '../../../../components/ui/selector/agyleDictionaryField';
import _ from 'lodash';
import {FormControl, InputLabel, MenuItem, Select} from '@mui/material';
import Chip from '@mui/material/Chip';


const useStyles = makeStyles((theme) => ({
    menuPaper: {
        maxHeight: 250
    },
    dayClass: {
        textAlign: "center", margin: "5px", cursor: "pointer"
    },
    dayOtherSmallMonth: {
        color: "grey",
        pointerEvents: "none"
    },
    selectedDaySmallClass: {
        color: "#cb1818",
        pointerEvents: "none"
    },
    textFieldClass: {
     //   backgroundColor: theme.palette.background.paper,
    //    border: "1px solid #5f5f5f",
      //  borderRadius: 3,
       // height: 55
    },
    inputLabel: {
        borderRadius: 3,
        color: "red",
        border: "1px solid #5f5f5f",
    },
}));


const LockTimeSlotModal = (props) => {

    const initLockSession = {
        lock: true,
        startTime: moment(),
        from: null,
        to: null,
        comment: null,
        workStationId: null
    }

    const {t, i18n} = useTranslation();

    const controller = new AbortController();
    const dispatch = useDispatch();
    const classes = useStyles();

    const [lockSession, setLockSession] = React.useState(initLockSession)
    const [activeSubmit, setActiveSubmit] = React.useState(false);
    const bookedAdmissionConfig = useSelector(getConfig);
    const [timeSlotDate, setTimeSlotDate] = React.useState(null);

    useEffect(()=>{
        if(bookedAdmissionConfig && bookedAdmissionConfig.lockSessionReasons && Array.isArray(bookedAdmissionConfig.lockSessionReasons)){
            setLockSession((lockSessionPrev) => {
                return {
                    ...lockSessionPrev,
                    comment: bookedAdmissionConfig.lockSessionReasons[0].label,
                }
            });
        }
    }, [bookedAdmissionConfig])



    useEffect(()=>{
        if(props.slotToEdit) {
            setLockSession((lockSessionTmp) => {
                let slotToEdit = _.cloneDeep(props.slotToEdit);
                let timeSlotStartTime = moment(slotToEdit.startTime)

                return {
                    lock: true,
                    startTime: timeSlotStartTime,
                    from: timeSlotStartTime,
                    to: moment(timeSlotStartTime).add(slotToEdit.timeLen, "minutes"),
                    comment: slotToEdit.comment,
                    workStationId: props.clickedWorkStation ? props.clickedWorkStation.id : null,
                }
            })
        }
    },[props.slotToEdit, props.session, props.clickedWorkStation])

    const getAvailableSlots = (sessionO) => {
        let session = _.cloneDeep(sessionO);
        if(session) {
            let sessionStartHour = moment(session.day);

            let sessionMaxTime = session.maxTime;
            let sessionEndHour = moment(session.day).add(sessionMaxTime, "minutes");
            let hourStart = moment(sessionStartHour);
            let sorted  = session.bookedSessions?.sort(function(x, y){ return x.startTime > y.startTime? 1: -1;});
            sorted = _.filter(sorted, e => {
                return !e.holdingPen;
            });
            if(props.clickedWorkStation) {
                sorted = _.filter(sorted, e => {
                    return e.workStationId === props.clickedWorkStation.id;
                });
            }
            let slots = [];


            sorted.forEach((op, index) => {

                let opStartTime = moment(op.startTime);
                let opEndTime = moment(opStartTime).add(op.timeLen, "minutes");

                if(opStartTime.diff(hourStart, "minutes") >= 1){
                    slots.push({
                        station: op.workStationId,
                        start: hourStart.format("HH:mm"),
                        end: opStartTime.format("HH:mm"),
                        len: opStartTime.diff(hourStart, "minutes")
                    })
                }

                hourStart =  opEndTime;

            });
            if(sessionEndHour.diff(hourStart, "minutes") > 1) {
                slots.push({
                    station: sorted[0]?.workStationId,
                    start: hourStart.format("HH:mm"),
                    end: sessionEndHour.format("HH:mm"),
                    len: sessionEndHour.diff(hourStart, "minutes")
                })
            }

            if(slots.length === 0) {
                if(sessionEndHour.diff(moment(hourStart), 'minutes') >= 0){
                    slots.push({
                        // station: sorted[0]?.workStationId,
                        start: moment(hourStart).format("HH:mm"),
                        len: sessionMaxTime
                    })
                }
            }

            return slots;
        } else {
            return []
        }

    }

    useEffect(()=>{

            if(timeSlotDate == null){
                setTimeSlotDate(moment(props.session.day));
            }
            let valid = true;
            if(props.session.hasOwnProperty("bookedSessions") && lockSession) {
                if(moment.isMoment(lockSession.from) && moment.isMoment(lockSession.to)) {
                    const bookedSessionStart = moment(props.session.day);
                    const bookedSessionEnd = moment(props.session.day).add(props.session.maxTime, 'minutes');

                    if (!lockSession.from.isBetween(bookedSessionStart, bookedSessionEnd, undefined, '[]')) {
                        valid = false;
                      //  console.log("lockSession.from isnt between session", lockSession.from, props.session);
                    }
                    if (!lockSession.to.isBetween(bookedSessionStart, bookedSessionEnd, undefined, '[]')) {
                        valid = false;
                     //   console.log("lockSession.to isnt between session", lockSession.to, props.session);
                    }
                    if (lockSession.to.isSameOrBefore(lockSession.from)) {
                        valid = false;
                     //   console.log("lockSession.to is before lockSession.from", lockSession.to, lockSession.from);
                    }
                    if (valid) {
                        _.forEach(props.session.bookedSessions, (operation) => {
                            if(!props.clickedWorkStation || (props.clickedWorkStation && props.clickedWorkStation.id === operation.workStationId)) {
                                let operationStarts = moment(operation.startTime);
                                let operationEnds = moment(operation.startTime).add(operation.timeLen, 'minutes');
                                if((!props.slotToEdit || props.slotToEdit.startTime !== operation.startTime) && !operation.holdingPen) {
                                    if (lockSession.from.isBetween(operationStarts, operationEnds)) {
                                        valid = false;
                                        //console.info("lockSession.from is between session", lockSession.from, ses);
                                    }
                                    if (lockSession.to.isBetween(operationStarts, operationEnds)) {
                                        valid = false;
                                        //console.info("lockSession.to is between session", lockSession.to, ses);
                                    }
                                }
                            }
                        });
                    }
                } else {
                    valid = false;
                }
            }
            setActiveSubmit(valid);

    }, [props.session, lockSession])

    useEffect(()=>{
        if(props.clickedHour && !props.slotToEdit) {
            setLockSession((lockSessionPrev) => {
                return {
                    ...lockSessionPrev,
                    from: props.clickedHour,
                    to: moment(props.clickedHour).add(10, 'minute'),
                }
            });
            setTimeSlotDate(moment(props.clickedHour));
        }
    }, [props.clickedHour])

    const getDataForTimeSlotToRemove = () => {
        return {
            comment: props.slotToEdit.comment,
            lock: true,
            operationId: null,
            time: moment.utc(props.slotToEdit.startTime).format("HH:mm"),
            opTimeLen:  props.slotToEdit.timeLen,
            theatreSessionId: props.session.id,
            workStationId: props.clickedWorkStation ? props.clickedWorkStation.id : null,
            remove: true
        }
    }

    const removeTimeSlot  = () => {
        if(props.slotToEdit) {
            API.theatreSessionsAddOperation(getDataForTimeSlotToRemove()).then(operations => {
                dispatch(reload());
                if(props.onClose)
                    props.onClose()
            }).catch(function (error) {
                // TODO: error handler !!!
                console.error(error);
            });
        }
    }

    const saveTimeSlot = async () => {
        if (props.slotToEdit) {
            await API.theatreSessionsAddOperation(getDataForTimeSlotToRemove()).then(operations => {

            }).catch(function (error) {
                // TODO: error handler !!!
                console.error(error);
            });
        }

        let data = {
            comment: lockSession.comment || "",
            lock: true,
            operationId: null,
            time: moment.utc(lockSession.from).format("HH:mm"),
            opTimeLen: lockSession.to.diff(lockSession.from, "minutes"),
            theatreSessionId: props.session.id,
            workStationId: props.clickedWorkStation ? props.clickedWorkStation.id : null
        }

        API.theatreSessionsAddOperation(data).then(operations => {
            dispatch(reload());
            if (props.onClose)
                props.onClose()
        }).catch(function (error) {
            // TODO: error handler !!!
            console.error(error);
        });
    }

    return (<Grid container spacing={2}>

        <Grid item xs={12}>
            <AgyleDatePicker
                value={timeSlotDate}
                label={t("Date")}
                type="date"
                textFieldClass={classes.textFieldClass}
                onChange={(e) => {}}
                disableFuture={false}
                disablePast={false}
                noBorder={false}
                disabled
            />

        </Grid>
        <Grid item xs={6}>
            <AgyleDatePicker
                value={lockSession.from}
                textFieldClass={classes.textFieldClass}
                label={t("From")}
                type="time"
                inputVariant="outlined"
                svgColor={"#ACAFB3"}
                error={false}
                noBorder={false}
                onChange={(e) => {
                    let currentTime = moment(e);
                    currentTime.year(timeSlotDate.get('year'));
                    currentTime.month(timeSlotDate.get('month'));
                    currentTime.date(timeSlotDate.get('date'));
                    setLockSession((prevState) => ({
                        ...prevState,
                        from: currentTime,
                    }));
                }}
            />
        </Grid>
        <Grid item xs={6}>
            <AgyleDatePicker
                value={lockSession.to}
                label={t("To")}
                textFieldClass={classes.textFieldClass}
                type="time"
                noBorder={false}
                InputProps={{classes: {root: classes.inputLabel}}}
                svgColor={"#ACAFB3"}
                onChange={(e) => {
                    let currentTime = moment(e);
                    currentTime.year(timeSlotDate.get('year'));
                    currentTime.month(timeSlotDate.get('month'));
                    currentTime.date(timeSlotDate.get('date'));
                    setLockSession((prevState) => ({
                        ...prevState,
                        to: currentTime,
                    }));
                }}
            />
        </Grid>
        <Grid item xs={12}>
            {getAvailableSlots(props.session)?.map((slot)=>{
                return  <Chip key={slot}
                              color={(lockSession.from?.format("HH:mm") === slot.start && lockSession.to?.format("HH:mm") === slot.end)? "primary": "secondary"}
                              style={{margin: 5, borderRadius: 6}}
                              onClick={()=>{
                                  let currentStart = moment(slot.start, "HH:mm");
                                  currentStart.year(timeSlotDate.get('year'));
                                  currentStart.month(timeSlotDate.get('month'));
                                  currentStart.date(timeSlotDate.get('date'));

                                  let currentEnd = moment(slot.end, "HH:mm");
                                  currentEnd.year(timeSlotDate.get('year'));
                                  currentEnd.month(timeSlotDate.get('month'));
                                  currentEnd.date(timeSlotDate.get('date'));

                                  setLockSession((prevState) => ({
                                      ...prevState,
                                      to: currentEnd,
                                      from: currentStart,
                                  }));
                              }}
                              label={`${slot.start} - ${slot.end} (${slot.len}min.)` }/>
            })}
        </Grid>

        <Grid item xs={12}>

            <FormControl variant="outlined" size={"small"} style={{width: "100%"}} >
                <InputLabel>Reason</InputLabel>
                <Select
                    name="urgentSlot"
                    label="Reason"
                    value={lockSession?.comment || ""}
                    onChange={(e) => {
                        setLockSession((prevState) => ({
                            ...prevState,
                            comment: e.target.value,
                        }));
                    }}
                >
                    {bookedAdmissionConfig?.lockSessionReasons.map((r)=>{
                        return   <MenuItem value={r.label}>{r.label}</MenuItem>
                    })}

                </Select>
            </FormControl>

        </Grid>

        <Grid item xs={12} style={{display: "flex", justifyContent: props.slotToEdit? "space-between": "flex-end"}}>
            {props.slotToEdit && <AgyleButton
                onClick={removeTimeSlot}
                variant="contained"
                colour="error"
                disabled={!activeSubmit}>
                Remove
            </AgyleButton>
            }

            <AgyleButton
                onClick={saveTimeSlot}
                variant="contained"
                disabled={!activeSubmit}>
               Submit
            </AgyleButton>
        </Grid>
    </Grid>)
}

export default LockTimeSlotModal